import React from "react"
import TextInput from "./TextInput";
import SelectInput from "./SelectInput";
import {rem} from "../utils/CSSUtils";
import Box from "./Box";
import CountryCodeList from '../utils/CountryCodeList'
import {toI18N} from "../utils/I18n";
import imageStyles from "../css/Image.module.css";

interface Props {
    id: string,
    phoneNumberValue?: string,
    defaultCountryCode?: { value: string, label: string },
    onSetPhoneNumber: (value: string) => void,
    onSetCountryCode: (value: string) => void,
    menuPlacement?: "auto" | "bottom" | "top",
    readonly?: boolean,
}

const formatOptionLabel = ({name, flag}: any) => (
    <>
        <img className={imageStyles.flag} src={flag} alt="flag"/>
        {`${name}`}
    </>
);

const SingleValue = ({data, selectProps}: any) => {
    if (!selectProps || !selectProps.getOptionValue) return null;
    return (
        <>
            <img className={imageStyles.flag} src={data.flag} alt="flag"/>
            {selectProps.getOptionValue(data)}
        </>
    )
};


export default (props: Props) => {
    const {id, phoneNumberValue, defaultCountryCode, readonly, onSetPhoneNumber, onSetCountryCode, menuPlacement} = props;

    return (
        <Box top>
            <Box center>
                <Box center style={{marginRight: rem(8), width: rem(135)}}>
                    <SelectInput
                        SingleValue={SingleValue}
                        formatOptionLabel={formatOptionLabel}
                        menuPlacement={menuPlacement}
                        defaultValue={defaultCountryCode}
                        readonly={readonly}
                        placeholder={toI18N("phone_number_select_placeholder")}
                        options={CountryCodeList}
                        onChange={onSetCountryCode}
                        isSearchable/>
                </Box>
                <Box center flex>
                    <TextInput id={id}
                               readonly={readonly}
                               inputMode={"tel"}
                               placeholder={toI18N("phone_number_input_placeholder")}
                               onChange={onSetPhoneNumber}
                               value={phoneNumberValue}
                               label={undefined}
                               hint={undefined}/>
                </Box>
            </Box>
        </Box>
    );
}
